import { render, staticRenderFns } from "./grade.vue?vue&type=template&id=f48a9a8c&scoped=true"
import script from "./grade.vue?vue&type=script&lang=ts"
export * from "./grade.vue?vue&type=script&lang=ts"
import style0 from "./grade.vue?vue&type=style&index=0&id=f48a9a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48a9a8c",
  null
  
)

export default component.exports